<script>
    import { onMount } from 'svelte';

    export let src;
    export let style = null;
    export let eleclass = null;

    let loaded = false;
    let failed = false;
    let loading = true;

    onMount(() => {
        const img = new Image();
        img.src = src;
        loading = true;

        img.onload = () => {
            loading = false;
            loaded = true;
        };

        img.onerror = () => {
            loading = false;
            failed = true;
        };
    });
</script>

{#if loaded}
	<img {src} alt="Image" style={(style)? style : ''} class={(eleclass)? eleclass : ''} on:click />
{:else if failed}
	<img src="https://icon-library.com/images/not-found-icon/not-found-icon-20.jpg" alt="Not Found" style={(style)? style : ''} class={(eleclass)? eleclass : ''} />
{:else if loading}
    <img src="build/assets/img/loading.svg" alt="Loading" style={(style)? style : ''} class={(eleclass)? eleclass : ''} />
{/if}

<style lang="scss">
	@import "src/scss/illustrations";
</style>